import { useState } from "react";
import TabsPanel from "../TabsPanel";
import { StripeManualSelectionProvider } from "../StripeManualSelection/context";
import { PlotSelectionProvider } from "../../context/PlotSelectionContext";
import "../../style.less";

const RatesDosagePanel = (): JSX.Element => {
  const [showAutoAssignment, setShowAutoAssignment] = useState(false);
  const [hasMockAssignments, setHasMockAssignments] = useState(false);

  return (
    <TabsPanel
      showAutoAssignment={showAutoAssignment}
      hasMockAssignments={hasMockAssignments}
      onShowAutoAssignment={setShowAutoAssignment}
      onCompleteAutoAssignment={() => {
        setHasMockAssignments(true);
        setShowAutoAssignment(false);
      }}
      onResetAssignments={() => {
        setShowAutoAssignment(false);
        setHasMockAssignments(false);
      }}
    />
  );
};

export const RatesDosagePreview = (): JSX.Element => (
  <PlotSelectionProvider>
    <StripeManualSelectionProvider>
      <RatesDosagePanel />
    </StripeManualSelectionProvider>
  </PlotSelectionProvider>
);

export default RatesDosagePanel;
